import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import { TrackableFile, CreateTrackableFile } from 'types/trackables';

import { useAPI } from 'hooks/api/useAPI';

type UseCreateTrackableFileParams = {
  trackable_list_id: string;
  trackable_item_id: string;
  data: CreateTrackableFile;
};

export function useCreateTrackableFile({
  onSuccess,
  onError,
  onSettled,
  ...options
}: UseMutationOptions<TrackableFile, APIError, UseCreateTrackableFileParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ trackable_list_id, trackable_item_id, data }: UseCreateTrackableFileParams) => {
      const response = await client.post(`/apps/${applicationID}/trackables/${trackable_list_id}/items/${trackable_item_id}/files`, data);
      return response.data;
    },
    {
      ...options,
      onSuccess: (...args) => {
        onSuccess?.(...args);
        queryClient.invalidateQueries(['trackable-files']);
      },
      onError,
      onSettled,
    }
  );
}